import { StarOffOutlineIcon } from './StarOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 297E76E3-B7A2-44A1-A340-F479AEFEF282
 * name star-off-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-off-outline.svg
 * tags
 */
export const FavoriteOffOutlineIcon = StarOffOutlineIcon;
export default FavoriteOffOutlineIcon